import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const StyleSection = () => {
  const [selectedStylist, setSelectedStylist] = useState(null);
  const [showModal, setShowModal] = useState(false);

  // Artist data for all sections
  const artistsData = {
    section1: [
      { name: 'KAREN', profession: 'SENIOR ELITE STYLIST', image: 'Karen.webp',fb:"https://www.facebook.com/karen2171", insta:"https://www.instagram.com/hairbykarennnn/" }
    ],
    section2: [
      { name: 'MACKENZIE', profession: 'ELITE STYLIST', image: 'Mackenzie.webp',fb:"https://www.facebook.com/mackenzie.holzworth", insta:"https://www.instagram.com/mackenzieholzworth_hair/" },
      { name: 'JENA', profession: 'ELITE STYLIST', image: 'Jena.webp',fb:"https://www.facebook.com/jena.sliker", insta:"https://www.instagram.com/hairrbyjenaa" }
    ],
    section3: [
      { name: 'ZHANA', profession: 'MASTER STYLIST', image: 'Zhana.webp',fb:"https://www.facebook.com/RusalkaQueen/", insta:"https://www.instagram.com/rusalkaqueen/" }
      //{ name: 'SABRINA', profession: 'MASTER STYLIST', image: 'Sabrina.webp',fb:"https://www.facebook.com/h2d4easton", insta:"https://www.instagram.com/h2d4easton/" }
    ],
    section4: [
      { name: 'AMANDA', profession: 'STYLIST', image: 'Amanda.webp' ,fb:"https://www.facebook.com/h2d4easton", insta:"https://www.instagram.com/hairbymandag/"},
      { name: 'ALEXA', profession: 'ASSISTANT', image: 'Alexa.webp' },
      //{ name: 'ADRIANA', profession: 'ASSISTANT', image: 'Adriana.webp' },
      //{ name: 'JAY', profession: 'ASSISTANT', image: 'Jay.webp' }
    ]
  };

  // Bio data for stylists (keeping existing bio data)
  const stylistBios = {
    KAREN: {
      role:"SENIOR ELITE STYLIST",
      experience: "17 Years of Experience",
      approach: "From custom color formulas to personalized at-home care tips, I believe dream hair is a collaboration. My job is to guide, be honest, educate, and deliver results that not only look amazing in the chair—but grow out gracefully and feel healthy.",
      specialties: "Balayage, Dimensional Blonding, Color Correction, Precision Haircuts, Flat tip hair extensions.",
      certifications: "Flat tip extensions.",
      favoriteServices: "Dimensional blonde, angled bob haircuts, long layered volume haircuts.",
      inspiration: "Connection to all my clients who have gotten me to where i am today! It's not just about the hair. It's the stories shared, the trust built, and the confidence I get to help people step into.",
      funFact: "Total swiftie.",
      quote: "The trash takes it's self out every single time - Taylor Swift"
    },
    MACKENZIE: {
  role: "ELITE STYLIST",
  experience: "13 Years of Experience",
  approach: "I treat every head of hair like a collaboration. I listen closely to my client's vision, but I also guide them with my professional knowledge—whether it's about what will suit their lifestyle, enhance their features, or keep their hair healthy long-term. My goal is to blend creativity with practicality so their dream hair isn't just for the salon chair—it's something they can love and maintain every day.",
  specialties: "Hair Extensions – Hand-Tied, Hair Extensions – Tape-In, Balayage, Dimensional Blonding, Color Correction, Precision Haircuts, Treatments (Keratin, Deep Conditioning, etc.), Flat tip beaded extensions",
  certifications: "Certified in Flat Tip • Tape-In • Hand-Tied Wefts. Seamless blends | Healthy hair | Custom transformations",
  favoriteServices: "Extensions, lived in natural color, high contrast dimensional color",
  inspiration: "What inspires me most is the transformation—watching someone's confidence shift the moment they see themselves in a new light. Hair isn't just hair to me; it's self-expression, empowerment, and sometimes even healing. I love being part of those moments where clients walk out not only looking different, but feeling unstoppable.",
  funFact: "Creating beautiful hair transformations is my passion, but outside the salon you'll usually find me around cars (especially Audis + '90s Volkswagens), soaking up beach town vibes, watching sunsets, or snuggled up with my animals. I also love helping at my dad's garage and working on the home we've been renovating over the years.",
  quote: "If you're going through hell, keep going."
},

    JENA: {
      role:"ELITE STYLIST",
      experience: "8 Years of Experience",
      approach: "My approach is all about collaboration. I listen closely to your vision, then use my expertise to guide you toward a look that feels both effortless and elevated. My goal is to deliver dream hair that not only looks amazing in the chair but fits seamlessly into your lifestyle.",
      specialties: "Balayage, Dimensional Blonding, Color Correction, Treatments (Keratin, Deep Conditioning, etc.)",
      certifications: "I am professionally trained in Brazilian Blowout, BB Free, and Cezanne smoothing systems, allowing me to offer clients a range of advanced treatments specific to their unique hair needs.",
      favoriteServices: "Some of my favorite services to offer behind the chair are blonding, seamless lived-in balayage, and transformative smoothing treatments. I love tailoring each of these to enhance my clients, natural beauty and lifestyle.",
      inspiration: "What inspires my work as a stylist is creating styles and looks that enhance confidence, celebrate individuality, and bring each client's unique vision to life through artistry and care.",
      funFact: "A fun fact about me is I actually started working at this very salon in high school, and it's been my home ever since. It's the only salon I've ever worked at, and I've grown up here behind the chair.",
      quote: "If you can dream it, you can do it."
    },
    ZHANA: {
      role:"MASTER STYLIST",
      experience: "6 Years of Experience",
      approach: "The art of it all is what inspires me the most. I was raised by two incredibly talented artist parents, so creativity has always been in my blood – even if I can't draw to save my life. Hair became my canvas, and every client who leaves my chair is essentially walking around with a piece of my art, which is endlessly exciting.",
      specialties: "Vivid/Fashion Colors, Precision Haircuts, Global Blonding.",
      certifications: "Extensions / Donna Bella Beaded Extensions. Extensions / Malia Weft Extensions. Keratin Treatments / Keratin Complex- certified in All of their different formulas. Brazilian Blow Out - regular and formaldehyde free. Certified Olaplex Professional. Certified K18 Pro. Redken Acidic Bonding Concentrate Cerified. Barbicide certified - certified in proper sanitation practices.",
      favoriteServices: "Custom Creative Color; Vivids; Extensions; Platinum Blonde; Color Melts; Bobs; Treatments; Tinsel and Feathers.",
      inspiration: "I especially love when clients bring me inspiration that isn't even hair related and trust me to interpret it in my own way – from landscapes and characters to animals, objects and I have even had someone bring a physical rock once. I draw inspiration from the world around us, and transforming it into something wearable is my favorite form of self-expression.",
      funFact: "I'm a bit of a jack-of-all trades when it comes to creativity. Before becoming a stylist, I earned a degree in Culinary Arts and Hospitality, Studied photography and business, and have been passionate about fashion design since I was 8 years old. I'm not one to sit still, so I've collected a million hobbies over the years— gardening, sewing, crocheting, embroidery, jewelry making, baking, cooking, collecting, home renovating, minitures, thrifting… if it's an art or a craft, I've probably tried it.",
      quote: "The people who matter, don't mind. And the people who mind, don't matter."
    },
    
SABRINA: {
  role: "MASTER STYLIST",
  experience: "8 Years of Experience",
  approach: "Being mindful of their budget and having great communication.",
  specialties: "Hair Extensions – Hand-Tied, Balayage, Dimensional Blonding, Color Correction, Vivid/Fashion Colors, Precision Haircuts, Bridal & Special Event Styling",
  certifications: "Coming soon...",
  favoriteServices: "Bridal / vivids / corrections",
  inspiration: "The people around me!",
  funFact: "I have three cats named after food: Zucchini, Beef Wellington, & Cosmopolitan.",
  quote: "Come as you are"
},
    AMANDA: {
      role:"STYLIST",
      experience: "4 Years of Experience",
      approach: "I combine a thorough consultation with advanced techniques to ensure each client's hair not only looks amazing when they leave the salon, but also stays healthy and easy to maintain at home.",
      specialties: "Hair Extensions – Tape-In, Balayage, Dimensional Blonding, Color Correction, Vivid/Fashion Colors, Precision Haircuts, Treatments (Keratin, Deep Conditioning, etc.)",
      certifications: "Tape-in extension certification. Advanced training in hair cutting.",
      favoriteServices: "I specialize in blonding and lived-in, low-maintenance colors, and I also love creating vibrant looks with rich reds and purples.",
      inspiration: "I'm inspired by the confidence and happiness my clients feel when they love their hair, nothing motivates me more than helping someone look and feel their best!",
      funFact: "A fun fact about me is when I'm not behind the chair you can usually find me snuggling with my dog Tilly.",
      quote: "Great hair doesn't happen by chance, it happens by appointment."
    }
  };

  // Modal Component
  const BioModal = ({ stylist, bio, onClose }) => {
    if (!stylist || !bio) return null;

    return (
      <div className="fixed inset-0 bg-black bg-opacity-75 z-50 flex items-center justify-center p-4 overflow-y-auto">
        <div className="bg-black text-white max-w-2xl w-full max-h-[90vh] overflow-y-auto relative rounded-lg">
          {/* Close button */}
          <button 
            onClick={onClose}
            className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors z-10 text-2xl"
          >
            ✕
          </button>

          {/* Content */}
          <div className="p-8 md:p-12">
            {/* Header */}
            <div className="text-left mb-8">
              <h2 className="text-3xl md:text-4xl font-bold mb-2" style={{ fontFamily: 'Montserrat, sans-serif', letterSpacing: '0.1em' }}>
                {stylist}
              </h2>
              {bio.role && (
                <p className="text-[#C7A064] text-lg" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  {bio.role}
                </p>
              )}
              {bio.experience && (
                <p className="text-[#C7A064] text-lg" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  {bio.experience}
                </p>
              )}
            </div>

            {/* Bio Sections */}
            <div className="space-y-6 text-left">
              {bio.approach && bio.approach !== "Coming soon..." && (
                <div>
                  <p className="text-gray-300 leading-relaxed" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                    {bio.approach}
                  </p>
                </div>
              )}

              {bio.specialties && bio.specialties !== "Coming soon..." && (
                <div>
                  <h3 className="text-[#C7A064] text-xl mb-3" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                    Primary Specialties
                  </h3>
                  <p className="text-gray-300" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                    {bio.specialties}
                  </p>
                </div>
              )}

              {bio.certifications && bio.certifications !== "Coming soon..." && (
                <div>
                  <h3 className="text-[#C7A064] text-xl mb-3" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                    Certifications or Advanced Training Completed
                  </h3>
                  <p className="text-gray-300" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                    {bio.certifications}
                  </p>
                </div>
              )}

              {bio.favoriteServices && bio.favoriteServices !== "Coming soon..." && (
                <div>
                  <h3 className="text-[#C7A064] text-xl mb-3" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                    Favorite Services
                  </h3>
                  <p className="text-gray-300" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                    {bio.favoriteServices}
                  </p>
                </div>
              )}

              {bio.inspiration && bio.inspiration !== "Coming soon..." && (
                <div>
                  <h3 className="text-[#C7A064] text-xl mb-3" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                    My Inspiration
                  </h3>
                  <p className="text-gray-300" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                    {bio.inspiration}
                  </p>
                </div>
              )}

              {bio.funFact && bio.funFact !== "Coming soon..." && (
                <div>
                  <h3 className="text-[#C7A064] text-xl mb-3" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                    Fun Fact or Something Unique About Me
                  </h3>
                  <p className="text-gray-300" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                    {bio.funFact}
                  </p>
                </div>
              )}

              {bio.quote && (
                <div className="pt-6 border-t border-gray-700">
                  <p className="text-[#C7A064] italic text-lg" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                    "{bio.quote}"
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const handleViewMore = (stylistName) => {
    setSelectedStylist(stylistName);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedStylist(null);
  };

  return (
    <div className="w-full">
      {/* Bio Modal */}
      {showModal && (
        <BioModal 
          stylist={selectedStylist} 
          bio={stylistBios[selectedStylist]} 
          onClose={closeModal}
        />
      )}

      {/* Section 1 - White Background */}
      <section className="w-full bg-white py-12 sm:py-16 lg:py-24">
        <div className="max-w-[1792px] mx-auto px-4 sm:px-6 lg:px-16">
          {/* Header Text with Background Stylists Text */}
          <div className="mb-8 sm:mb-12 relative">
            {/* Background "Stylists" text - Responsive */}
            <div 
              className="absolute inset-0 flex justify-center items-center pointer-events-none opacity-30 sm:opacity-100"
              style={{ 
                fontFamily: 'Quentin',
                fontSize: 'clamp(80px, 15vw, 160px)',
                color: '#F2EADC',
                fontWeight: '400',
                lineHeight: 'normal',
                fontStyle: 'normal'
              }}
            >
              Stylists
            </div>
            {/* Main Header Text */}
            <div className="relative z-10 text-center">
              <h2 className="text-2xl sm:text-3xl lg:text-5xl font-montserrat font-bold text-black mb-4 sm:mb-6">
                YOUR HAIR EXPERTS
              </h2>
              <p className="text-sm sm:text-base lg:text-lg text-gray-600 max-w-2xl mx-auto px-4 sm:whitespace-nowrap">
  Meet our team of amazing stylist, dedicated to creating a look just for you.
</p>
            </div>
          </div>

          {/* Title for Section 1 */}
          <h3
  className="mb-6 sm:mb-8 px-4 sm:px-0 uppercase"
  style={{
    color: '#000',
    textAlign: 'center',
    fontFamily: 'Montserrat',
    fontSize: '16px',
    fontWeight: '600',  // Changed from '400' to '600' for SemiBold
    lineHeight: '100%',
    letterSpacing: '0.2em'
  }}
>
  Meet Our Senior Elite Stylist
</h3>

          
          {/* Artists Grid - Responsive */}
{/* Artists Grid - Responsive */}
<div className="flex flex-wrap justify-center gap-6 sm:gap-8">
  {/* Individual Artists */}
  {artistsData.section1.map((artist, index) => (
    <div key={index} className="flex flex-col w-full sm:w-[calc(50%-1rem)] lg:w-[calc(25%-1.5rem)] max-w-sm">
      <div className="aspect-[2/3] w-full overflow-hidden mb-4">
        <img
          src={`/images/Artists/${artist.image}`}
          alt={artist.name}
          className="w-full h-full object-cover"
        />
      </div>
      <h4 className="text-lg font-montserrat font-bold text-center">{artist.name}</h4>
      {artist.profession && (
        <p className="text-xs sm:text-sm text-gray-600 text-center uppercase tracking-wider">{artist.profession}</p>
      )}
      <div className="flex justify-center items-center gap-3 mt-3">
        <a href={artist.fb} className="hover:opacity-80 transition-opacity">
          <img src="/images/Artists/fb_small.png" alt="Facebook" className="w-13 h-35" />
        </a>
        <div className="w-px h-5 bg-gray-400"></div>
        <a href={artist.insta} className="hover:opacity-80 transition-opacity">
          <img src="/images/Artists/insta_small.png" alt="Instagram" className="w-18 h-35" />
        </a>
      </div>
      <div className="flex justify-center mt-4 sm:mt-6">
        <button
          onClick={() => handleViewMore(artist.name)}
          className="text-[#C7A064] font-montserrat text-xs sm:text-sm font-medium tracking-[0.2em] uppercase hover:text-[#b08954] transition-colors duration-300 pb-1 border-b-2 border-[#C7A064] hover:border-[#b08954]"
          style={{
            fontWeight: '700',
          }}>
          Get To Know Your Stylist
        </button>
      </div>
    </div>
  ))}
</div>
        </div>
      </section>

      {/* Section 2 - Black Background */}
      <section className="w-full bg-black py-12 sm:py-16 lg:py-24">
        <div className="max-w-[1792px] mx-auto px-4 sm:px-6 lg:px-16">
          {/* Title for Section 2 */}
          <h3 
            className="mb-6 sm:mb-8 px-4 sm:px-0 uppercase"
            style={{
              color: 'white',
              textAlign: 'center',
              fontFamily: 'Montserrat',
              fontSize: '16px',
              fontStyle: 'normal',
              fontWeight: '600',
              lineHeight: '100%',
              letterSpacing: '0.2em'
            }}
          >
            Meet Our Elite Stylists
          </h3>

          {/* Artists Grid - Responsive */}
<div className="flex flex-wrap justify-center gap-6 sm:gap-8">
  {/* Individual Artists */}
  {artistsData.section2.map((artist, index) => (
    <div key={index} className="flex flex-col w-full sm:w-[calc(50%-1rem)] lg:w-[calc(25%-1.5rem)] max-w-sm">
      <div className="aspect-[2/3] w-full overflow-hidden mb-4">
        <img
          src={`/images/Artists/${artist.image}`}
          alt={artist.name}
          className="w-full h-full object-cover"
        />
      </div>
      <h4 className="text-lg font-montserrat font-bold text-center text-white">{artist.name}</h4>
      <p className="text-xs sm:text-sm text-gray-400 text-center uppercase tracking-wider">{artist.profession}</p>
      <div className="flex justify-center items-center gap-3 mt-3">
        <a href={artist.fb} className="hover:opacity-80 transition-opacity">
          <img src="/images/Artists/I_white.png" alt="Instagram" className="w-13 h-35" />
        </a>
        <div className="w-px h-5 bg-gray-600"></div>
        <a href={artist.insta} className="hover:opacity-80 transition-opacity">
          <img src="/images/Artists/f_white.png" alt="Facebook" className="w-18 h-35" />
        </a>
      </div>
      <div className="flex justify-center mt-4 sm:mt-6">
        <button
          onClick={() => handleViewMore(artist.name)}
          className="text-[#C7A064] font-montserrat text-xs sm:text-sm font-medium tracking-[0.2em] uppercase hover:text-[#b08954] transition-colors duration-300 pb-1 border-b-2 border-[#C7A064] hover:border-[#b08954]"
          style={{
            fontWeight: '700',
          }}>
          Get To Know Your Stylist
        </button>
      </div>
    </div>
  ))}
</div>
        </div>
      </section>

      {/* Section 3 - White Background */}
      <section className="w-full bg-white py-12 sm:py-16 lg:py-24">
        <div className="max-w-[1792px] mx-auto px-4 sm:px-6 lg:px-16">
          {/* Title for Section 3 */}
          <h3 
            className="mb-6 sm:mb-8 px-4 sm:px-0 uppercase"
            style={{
              color: '#000',
              textAlign: 'center',
              fontFamily: 'Montserrat',
              fontSize: '16px',
              fontStyle: 'normal',
              fontWeight: '600',
              lineHeight: '100%',
              letterSpacing: '0.2em'
            }}
          >
            Meet Our Master Stylist
          </h3>

          {/* Artists Grid - Responsive */}
<div className="flex flex-wrap justify-center gap-6 sm:gap-8">
  {/* Individual Artists */}
  {artistsData.section3.map((artist, index) => (
    <div key={index} className="flex flex-col w-full sm:w-[calc(50%-1rem)] lg:w-[calc(25%-1.5rem)] max-w-sm">
      <div className="aspect-[2/3] w-full overflow-hidden mb-4">
        <img
          src={`/images/Artists/${artist.image}`}
          alt={artist.name}
          className="w-full h-full object-cover"
        />
      </div>
      <h4 className="text-lg font-montserrat font-bold text-center">{artist.name}</h4>
      <p className="text-xs sm:text-sm text-gray-600 text-center uppercase tracking-wider">{artist.profession}</p>
      <div className="flex justify-center items-center gap-3 mt-3">
        <a href={artist.fb} className="hover:opacity-80 transition-opacity">
          <img src="/images/Artists/fb_small.png" alt="Facebook" className="w-13 h-35" />
        </a>
        <div className="w-px h-5 bg-gray-400"></div>
        <a href={artist.insta} className="hover:opacity-80 transition-opacity">
          <img src="/images/Artists/insta_small.png" alt="Instagram" className="w-18 h-35" />
        </a>
      </div>
      <div className="flex justify-center mt-4 sm:mt-6">
        <button
          onClick={() => handleViewMore(artist.name)}
          className="text-[#C7A064] font-montserrat text-xs sm:text-sm font-medium tracking-[0.2em] uppercase hover:text-[#b08954] transition-colors duration-300 pb-1 border-b-2 border-[#C7A064] hover:border-[#b08954]"
          style={{
            fontWeight: '700',
          }}>
          Get To Know Your Stylist
        </button>
      </div>
    </div>
  ))}
</div>
        </div>
      </section>

      {/* Section 4 - F4F4F4 Background - Most Complex Section */}
     <section className="w-full">
  {/* Stylist Section - Gray Background */}
  <div className="bg-[#F4F4F4] py-12 sm:py-16 lg:py-24">
    <div className="max-w-[1792px] mx-auto px-4 sm:px-6 lg:px-16">
      {/* Title for Stylist Section */}
      <h3
        className="mb-6 sm:mb-8 text-center uppercase"
        style={{
          color: '#000',
          fontFamily: 'Montserrat',
          fontSize: '16px',
          fontWeight: '600',
          lineHeight: '100%',
          letterSpacing: '0.2em',
          textTransform: 'uppercase'
        }}
      >
        Meet Our Stylist
      </h3>
      {/* Amanda image with info */}
      <div className="flex justify-center">
        <div className="flex flex-col items-center max-w-sm">
          <div className="aspect-[2/3] w-full overflow-hidden mb-4">
            <img
              src={`/images/Artists/${artistsData.section4[0].image}`}
              alt={artistsData.section4[0].name}
              className="w-full h-full object-cover"
            />
          </div>
          <h4 className="text-lg font-montserrat font-bold text-center">{artistsData.section4[0].name}</h4>
          <p className="text-xs sm:text-sm text-gray-600 text-center uppercase tracking-wider mb-3">{artistsData.section4[0].profession}</p>
          <div className="flex justify-center items-center gap-3 mb-4">
            <a href={artistsData.section4[0].fb} className="hover:opacity-80 transition-opacity">
              <img src="/images/Artists/fb_small.png" alt="Facebook" className="w-13 h-35" />
            </a>
            <div className="w-px h-5 bg-gray-400"></div>
            <a href={artistsData.section4[0].insta} className="hover:opacity-80 transition-opacity">
              <img src="/images/Artists/insta_small.png" alt="Instagram" className="w-18 h-35" />
            </a>
          </div>
          <div className="flex justify-center">
            <button
              onClick={() => handleViewMore(artistsData.section4[0].name)}
              className="text-[#C7A064] font-montserrat text-xs sm:text-sm font-medium tracking-[0.2em] uppercase hover:text-[#b08954] transition-colors duration-300 pb-1 border-b-2 border-[#C7A064] hover:border-[#b08954]"
              style={{
                fontWeight: '700',
              }}>
              Get To Know Your Stylist
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  {/* Assistants Section - White Background */}
  <div className="bg-white py-12 sm:py-16 lg:py-24">
    <div className="max-w-[1792px] mx-auto px-4 sm:px-6 lg:px-16">
      <h3
        className="mb-6 sm:mb-8 text-center uppercase"
        style={{
          color: '#000',
          fontFamily: 'Montserrat',
          fontSize: '16px',
          fontWeight: '600',
          lineHeight: '100%',
          letterSpacing: '0.2em',
          textTransform: 'uppercase'
        }}
      >
        Meet Our Assistant
      </h3>
      {/* Assistant (Alexa) */}
<div className="grid grid-cols-1 gap-6 sm:gap-8 max-w-sm mx-auto">
  {artistsData.section4.slice(1).map((artist, index) => (
    <div key={index} className="flex flex-col items-center">
      <div className="aspect-[2/3] w-full overflow-hidden mb-4">
        <img
          src={`/images/Artists/${artist.image}`}
          alt={artist.name}
          className="w-full h-full object-cover"
        />
      </div>
      <h4 className="text-lg font-montserrat font-bold text-center">{artist.name}</h4>
      <p className="text-xs sm:text-sm text-gray-600 text-center uppercase tracking-wider">{artist.profession}</p>
    </div>
  ))}
      </div>
    </div>
  </div>
</section>
    </div>
  );
};

export default StyleSection;